import styled from 'styled-components';

export const TooltipBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${(p) => p.theme.spacing?.md ?? '12px'};
`;

export const TooltipPrice = styled.em`
  font-style: italic;
  opacity: 0.85;
`;
